/**
 * @todo Move this to a shared patH because it is used in multiple places
 */
export const salesStageOptions = [
  { label: "Sin ventas", value: "NO_SALES" },
  { label: "Producto lanzado", value: "LAUNCH" },
  { label: "Ingresos estables", value: "INCOME" }
];
